import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

/**
 * Protects dashboard routes — redirects to /login if not authenticated.
 * Optionally checks role from route data: { roles: ['1','2'] }
 */
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    router.navigate(['/login']);
    return false;
  }

  // Check role-based access if roles are defined in route data
  const allowedRoles = route.data?.['roles'] as string[] | undefined;
  if (allowedRoles && allowedRoles.length > 0) {
    const userRole = authService.getUserRole();
    if (!userRole || !allowedRoles.includes(userRole)) {
      // User is logged in but doesn't have the right role — send to their correct dashboard
      const correctRoute = authService.getDashboardRoute(
        userRole || '',
        authService.getUser()?.roleName,
      );
      router.navigate([correctRoute]);
      return false;
    }
  }

  return true;
};

/**
 * Prevents logged-in users from accessing /login — redirects to their dashboard.
 */
export const loginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    const user = authService.getUser();
    if (user) {
      const dashboardRoute = authService.resolveDashboardRoute(user);
      router.navigate([dashboardRoute]);
      return false;
    }
  }

  return true;
};
